import React, { memo } from 'react';
import classNames from 'classnames/bind';
import styles from './ReportAccidentInfoItem.module.scss';

const cx = classNames.bind(styles);

function ReportAccidentInfoItem({ itemData = {}, children = '', handleAccordionMulti, accordionArray, accordionStatsAll }) {
	return (
		<dl className={cx('item_accident', { on: accordionArray[itemData.id] || !accordionStatsAll })}>
			<dt className={cx('tit_contents')}>
				<button
					className={cx('btn')}
					onClick={() => handleAccordionMulti(itemData.id)}
				>
					{itemData.title}
				</button>
			</dt>
			<dd className={cx('contents')}>{children}</dd>
		</dl>
	);
}

export default memo(ReportAccidentInfoItem);
